import { GridCellProps } from '@progress/kendo-react-grid';
import { useInternationalization } from '@progress/kendo-react-intl';
import GridCellBase from 'src/components/GridCellBase';

const AmountSubCell = (props: GridCellProps) => {
  const { field = '', dataItem } = props;
  const intl = useInternationalization();

  const value1 = dataItem[field]?.toString();
  const formatted =
    Number(value1) < 0
      ? '-$' + intl.format('{0:n2}', Math.abs(Number(value1)) || 0)
      : '$' + intl.format('{0:n2}', Number(value1) || 0);
  return (
    <GridCellBase {...props} title={formatted}>
      <p className="text-right">{formatted}</p>
    </GridCellBase>
  );
};

export default AmountSubCell;
